import React from 'react';
import { Button } from 'antd';
import classnames from 'classnames';
import qs from 'query-string';
import { generatePath, useHistory } from 'react-router';
import { LABELS_CONFIG } from '@/Hooks/PUJ/constants';
import getLabel from '@/Utils/LabelsConfig';
import { RoutePath } from '@/Routes/RoutePath';
import styles from '../styles.module.scss';

const PurchageSuccess = ({ packageName, collectionId, origin }) => {
  const history = useHistory();
  const onDismiss = () => {
    if (origin) {
      history.push(origin);
    } else {
      history.goBack();
    }
  };
  const onBrowse = () => {
    const path = qs.stringifyUrl({
      url: generatePath(RoutePath.browseCollection, {
        collectionId,
      }),
      query: {},
    });
    history.push(path);
  };

  return (
    <div className={styles.formContainer}>
      <h1>{getLabel(LABELS_CONFIG.THANKS_TO_GOT, { packageName }, true)}</h1>

      <div className={classnames(styles.description, styles.purchageDescription)}>
        {getLabel(LABELS_CONFIG.UPDATED_SUBSCRIPTION)}
      </div>

      <div className={styles.buttonsContainer}>
        {collectionId && (
          <Button type="primary" data-testid="purchage-success-browse-button" onClick={onBrowse}>
            BROWSE {packageName}
          </Button>
        )}
        <Button
          className={styles.secondary}
          type="primary"
          htmlType="submit"
          data-testid="purchage-success-dismiss-button"
          onClick={onDismiss}
        >
          DISMISS
        </Button>
      </div>
    </div>
  );
};
export default PurchageSuccess;
